import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  CardHeader,
  Button,
  Spinner,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import Messageservice from "../../../services/KangarooServices/MessageService";
import toast from "react-hot-toast";
import { imageBaseApi } from "../../../utilis/imageHelper";
import { Triangle } from "react-loader-spinner";

const CEOmessage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const result = await Messageservice.getList();
      setData(result);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load messages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Toggle delete modal
  const toggleDeleteModal = (item = null) => {
    setSelectedItem(item);
    setDeleteModal(!deleteModal);
  };

  // Handle delete
  const handleDelete = async () => {
    if (!selectedItem) return;

    setDeleting(true);
    try {
      await Messageservice.delete(selectedItem.id);
      toast.success("Message deleted successfully");
      fetchData(); // Refresh list
      toggleDeleteModal();
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error(error?.response?.data?.message || "Failed to delete message");
    } finally {
      setDeleting(false);
    }
  };

  // Strip HTML tags for preview
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Truncate text
  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    const stripped = stripHtml(text);
    return stripped.length > maxLength
      ? stripped.substring(0, maxLength) + "..."
      : stripped;
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb pageTitle="Content Management" title="Message From CEO" />

        {/* <Row className="mb-4">
          <Col className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">All Messages ({data.length})</h5>
            <button
              className="btn btn-success"
              onClick={() => navigate('/message-from-ceo/create')}
            >
              <i className="ri-add-line me-1"></i>Add Message
            </button>
          </Col>
        </Row> */}

        {loading ? (
          <Row>
            <Col className="text-center py-5">
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            </Col>
          </Row>
        ) : data.length === 0 ? (
          <Row>
            <Col>
              <Card>
                <CardBody className="text-center py-5">
                  <i className="ri-message-3-line display-4 text-muted"></i>
                  <h5 className="mt-3 mb-2">No Messages Found</h5>
                  <p className="text-muted mb-4">
                    Get started by creating your first CEO message
                  </p>
                  <Button
                    color="success"
                    onClick={() => navigate("/message-from-ceo/create")}
                  >
                    <i className="ri-add-line me-1"></i>Create Message
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row>
            {data.map((item) => (
              <Col lg={12} key={item.id} className="mb-4">
                <Card className="h-100 shadow-sm hover-shadow-lg transition">
                  <CardHeader className="bg-light">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <h5 className="mb-1 text-truncate fw-semibold">
                          {item.heading}
                        </h5>
                        {item.ceoImage && (
                          <div className="mb-3">
                            <img
                              src={`${imageBaseApi}${item.ceoImage.url}`}
                              alt={item.heading}
                              className="img-fluid rounded"
                              style={{
                                width: "100%",
                                height: "200px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        )}

                        {item.subHeading && item.subHeading !== "null" && (
                          <div
                            className="mt-1 px-2 py-1 rounded bg-info bg-opacity-10 text-info small fw-medium"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 3,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                          >
                            {item.subHeading}
                          </div>
                        )}

                        <small className="text-muted d-block mt-2">
                          <i className="ri-link me-1"></i>
                          {item.slug}
                        </small>
                      </div>
                    </div>
                  </CardHeader>

                  <CardBody>
                    {/* CEO Image */}

                    {/* Message Preview */}
                    {item.message && (
                      <div className="mb-3">
                        <p className="text-muted small mb-0">
                          {truncateText(item.message, 120)}
                        </p>
                      </div>
                    )}

                    {/* Action Buttons */}
                    <div className="d-flex gap-2 mt-3">
                      <Button
                        color="warning"
                        size="sm"
                        outline
                        
                        onClick={() =>
                          navigate(`/message-from-ceo/update/${item.id}`)
                        }
                      >
                        <i className="ri-edit-line me-1"></i>Edit
                      </Button>
                      <Button
                        color="primary"
                        size="sm"
                        outline

                        onClick={() => navigate(`/message-from-ceo/details/${item.slug}`)}
                        
                      >
                        <i className="ri-edit-line">Details</i>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {/* Delete Confirmation Modal */}
        <Modal isOpen={deleteModal} toggle={() => toggleDeleteModal()} centered>
          <ModalHeader toggle={() => toggleDeleteModal()}>
            Confirm Delete
          </ModalHeader>
          <ModalBody>
            <div className="text-center">
              <i className="ri-delete-bin-line display-4 text-danger"></i>
              <h5 className="mt-3 mb-2">Are you sure?</h5>
              <p className="text-muted mb-0">
                Do you want to delete the message{" "}
                <strong>"{selectedItem?.heading}"</strong>? This action cannot
                be undone.
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="light"
              onClick={() => toggleDeleteModal()}
              disabled={deleting}
            >
              Cancel
            </Button>
            <Button color="danger" onClick={handleDelete} disabled={deleting}>
              {deleting ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Deleting...
                </>
              ) : (
                <>
                  <i className="ri-delete-bin-line me-1"></i>Delete
                </>
              )}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default CEOmessage;
